export const API_URL = 'https://api.cumulus.rip'
export const FAPI_URL = 'https://www.cumulus.rip'
// export const API_URL = 'http://localhost:3000'
// export const FAPI_URL = 'http://localhost:3001'
